<template>
  <div>
    <div class="item">
      <div class="heading">
        <div>
          <div class="icon">
            <span
              v-if="
                zipCode
              ">
              {{ zipCode }}
            </span>
            <div
              class="empty" v-else>
              รหัส<br>ไปรณีย์
            </div>
          </div>
        </div>
        <div class="detail">
          <div>
            <p>
              <b v-if="tumbonName">
                {{ tumbonName }}
              </b>
              <span v-else class="unknown">
                แขวง/ตำบล
              </span>
            </p>
            <p
              v-if="
                amphurName
              ">
              {{ amphurName }}
            </p>
            <p v-else class="unknown">
              เขต/อำเภอ
            </p>
          </div>
          <div>
            <p
              v-if="
                provinceName
              ">
              {{ provinceName }}
            </p>
            <p v-else class="unknown">
              จังหวัด
            </p>
          </div>
        </div>
      </div>
      <div class="action">
        <el-button
          type="sc-asset"
          class="
            item-action
          "
          @click="
            modal.open = true
          ">
          {{ valid ? 'เปลี่ยน' : 'เลือก'}}
        </el-button>
      </div>
    </div>

    <el-dialog
      :visible.sync="modal.open"
      :close-on-click-modal="false">

      <div
        slot="title"
        class="
          dialog-title
        ">
        <el-button
          v-if="
            ui.location
          "
          type="text"
          class="
            back-button
          "
          icon="
            el-icon-arrow-left
          "
          @click="
            () => ui.province = true
          ">
          กลับ
        </el-button>
        <b>
          {{ modal.title }}
        </b>
      </div>

      <Province
        v-if="
          ui.province
        "
        :selected="
          province.code ||
          province.name
        "
        :reset="
          modal.open
        "
        @selected="
          selectProvince
        "
        @loading="
          value => loader = value
        "
      />

      <Location
        v-if="
          ui.location
        "
        :selected="
          location.tumbonCode ||
          location.tumbonName
        "
        :provinceCode="
          province.code
        "
        @selected="
          selectLocation
        "
        @loading="
          value => loader = value
        "
      />
    </el-dialog>

    <!-- Loader -->
    <div 
      v-loading.fullscreen.lock="loader"
      element-loading-background="rgba(0, 0, 0, 0.4)">
    </div>
  </div>
</template>

<script lang="js">

// Components
import Province from './NonScAddressProvince.vue'
import Location from './NonScAddressLocation.vue'

// Common
import { NonScCommon } from '../common/nonsc.common'

// Utils
import {
  ValidateUtility as Validate
} from '../utils/validate'

export default {
  components: {
    Province,
    Location
  },
  props: {
    open: Boolean,
    selected: {
      default () {
        return NonScCommon.location
      }
    }
  },
  data() {

    // Init Modal State
    const modal = {
      open  : false,
      title : 'เลือกสถานที่ตั้ง'
    }

    // Init UI State
    const ui = {
      province: false,
      location: false,
    }

    // Init Loader State
    const loader = false

    // Init Province State
    const province = {
      code: null, name: null
    }

    // Init Location State
    const location = (
      Object.assign({}, NonScCommon.location)
    )

    return {
      modal,
      ui,
      loader,
      province,
      location,
    }
  },
  watch: {
    open(value) {
      this.modal.open = value
    },
    selected: {
      handler (value) {
        if (value) {
          this.location = value
        }      
      },
      deep: true
    },
    'modal.open'(value) {
      
      // Emit Event
      this.$emit('open', value)

      // Init UI
      if (value) {
        this.ui.province = true
      }
    },
    'ui.province' (value) {
      if (value) {
        
        // Set Location UI
        this.ui.location = false
        
        // Set UI Title
        this.modal.title = 'เลือกจังหวัด'
      }
    },
    'ui.location' (value) {

      // Validate Location
      if (!this.province) return
      
      // Location Props
      const { code, name } = this.province
      
      // Validate UI
      if (value && code) {
        
        // Set Province UI
        this.ui.province = false

        // Set UI Title
        this.modal.title = `จังหวัด${name}`
      }
    },
  },
  async mounted() {

    // Init Selected
    this.location = this.selected

    // Init Modal
    setTimeout(
      () => this.modal.open = this.open, 400
    )
  },
  computed: {
    valid() {
      return Validate.isLocation(this.location)
    },
    tumbonName() {

      // Validate Location
      if (!this.location) return

      // Location Props
      const {
        tumbonPrefix,
        tumbonName
      } = this.location
      
      // Validate Props
      if (!tumbonPrefix || !tumbonName) return null

      return (
        tumbonPrefix + tumbonName
      )
    },
    amphurName() {

      // Validate Location
      if (!this.location) return

      // Location Props
      const {
        amphurPrefix,
        amphurName
      } = this.location
      
      // Validate Props
      if (!amphurPrefix || !amphurName) return null

      return (
        amphurPrefix + amphurName
      )
    },
    provinceName() {

      // Validate Location
      if (!this.location) return

      // Location Props
      const { provinceName } = this.location
      
      // Validate Props
      if (!provinceName) return null

      return `จังหวัด${provinceName}`
    },
    zipCode() {
      
      // Validate Location
      if (!this.location) return

      // Location Props
      const { zipCode } = this.location

      return zipCode
    }
  },
  methods: {
    selectProvince(province) {
      
      // Set Province
      this.province = province

      // Set Location UI
      this.ui.location = true
    },
    selectLocation(value) {

      // Set Location
      this.location = value

      // Emit Selected
      this.$emit(
        'selected', value
      )
      
      // Close Modal
      this.modal.open = false
    },
    reset() {
      this.location = NonScCommon.location
    }
  }
}

</script>

<style lang="css" scoped>


p {
  line-height: 1.5rem;
}

.item {
  align-items : center;
  gap         : var(--size-md);
  padding     : var(--size-md);
}

.item .heading {
  display     : flex;
  gap         : var(--size-md);
  align-items : center;
  flex        : 1;
}

.item .icon {
  min-width   : 4.5rem;
  font-weight : bold;
  text-align  : center;
  padding     : var(--size-xs);
  background  : var(--color-light);
  color       : var(--color-primary);
}
.icon .empty {
  text-align  : center;
  font-size   : .9rem;
}
.item .item-action {
  font-size : var(--size-md);
  padding   : var(--size-xs) var(--size-md);
}

.detail {
  display     : flex;
  flex        : 1;
  gap         : var(--size-md);
  align-items : center;
}
.detail > div {
  flex: 1;
}

.page-content {
  padding: var(--size-lg);
}
.page-content .content {
  overflow: auto;
}

.dialog-footer {
  display         : flex;
  justify-content : center;
}

.dialog-title {
  display     : flex;
  gap         : var(--size-sm);
  align-items : center;
}
.dialog-title .back-button {
  padding: var(--size-sm) 0;
}

@media screen and (max-width: 640px) {
  
  .item {
    flex-direction  : column;
    align-items     : flex-end;
    gap             : .75rem;
    padding         : .75rem;
  }
  .item .detail {
    align-items     : flex-start;
    flex-direction  : column;
    gap             : 0;
  }
  .item .heading {
    align-items : flex-start;
    width       : 100%;
  }
}

</style>


// WEBPACK FOOTER //
// src/features/nonsc/components/NonScAddress.vue